const ACCOUNT_CODES = {
    U001: 'ACCOUNT_NOT_FOUND',
    U004: 'COMPANY_OWNER_ALREADY_ASSIGNED',
    U002: 'ACCOUNT_ALREADY_EXIST',
};

export default ACCOUNT_CODES;
